import React from 'react';
import PropTypes from 'prop-types'; // Importações diretas dos ícones mais usados

import PencilOutlineIcon from 'mdi-react/PencilOutlineIcon';
import PencilIcon from 'mdi-react/PencilIcon';
import DeleteForeverIcon from 'mdi-react/DeleteForeverIcon';
import CloseIcon from 'mdi-react/CloseIcon';
import CheckIcon from 'mdi-react/CheckIcon';
import BlockHelperIcon from 'mdi-react/BlockHelperIcon';
import MagnifyIcon from 'mdi-react/MagnifyIcon';
import AccountEditIcon from 'mdi-react/AccountEditIcon';
import AccountPlusIcon from 'mdi-react/AccountPlusIcon';
import AccountRemoveIcon from 'mdi-react/AccountRemoveIcon';
import AccountMultipleIcon from 'mdi-react/AccountMultipleIcon';
import AccountGroupIcon from 'mdi-react/AccountGroupIcon';
import KeyVariantIcon from 'mdi-react/KeyVariantIcon';
import ChevronDownIcon from 'mdi-react/ChevronDownIcon';
import ChevronUpIcon from 'mdi-react/ChevronUpIcon';
import ChevronLeftIcon from 'mdi-react/ChevronLeftIcon';
import ChevronRightIcon from 'mdi-react/ChevronRightIcon';
import ChevronDoubleLeftIcon from 'mdi-react/ChevronDoubleLeftIcon';
import ChevronDoubleRightIcon from 'mdi-react/ChevronDoubleRightIcon';
import SortIcon from 'mdi-react/SortIcon';
import SortAscendingIcon from 'mdi-react/SortAscendingIcon';
import SortDescendingIcon from 'mdi-react/SortDescendingIcon';
import EyeIcon from 'mdi-react/EyeIcon';
import EyeOffIcon from 'mdi-react/EyeOffIcon';
import LoadingIcon from 'mdi-react/LoadingIcon';
import AutorenewIcon from 'mdi-react/AutorenewIcon';
import EmailIcon from 'mdi-react/EmailIcon';
import MailIcon from 'mdi-react/MailIcon';
import NotificationsIcon from 'mdi-react/NotificationsIcon';
import PaperclipIcon from 'mdi-react/PaperclipIcon';
import FileIcon from 'mdi-react/FileIcon';
import StarIcon from 'mdi-react/StarIcon';
import FacebookIcon from 'mdi-react/FacebookIcon';
import GooglePlusIcon from 'mdi-react/GooglePlusIcon';
import MicrosoftOfficeIcon from 'mdi-react/MicrosoftOfficeIcon';
import SettingsIcon from 'mdi-react/SettingsIcon';
import WalletIcon from 'mdi-react/WalletIcon';
import MenuIcon from 'mdi-react/MenuIcon';
import PlusIcon from 'mdi-react/PlusIcon';
import MinusIcon from 'mdi-react/MinusIcon';
import ArrowLeftIcon from 'mdi-react/ArrowLeftIcon';
import ArrowRightIcon from 'mdi-react/ArrowRightIcon';
import PrinterIcon from 'mdi-react/PrinterIcon';
import ReplyIcon from 'mdi-react/ReplyIcon';
import FilterListIcon from 'mdi-react/FilterListIcon';
import AvTimerIcon from 'mdi-react/AvTimerIcon';
import AccountOutlineIcon from 'mdi-react/AccountOutlineIcon';
import AccountSearchIcon from 'mdi-react/AccountSearchIcon';
import AlternateEmailIcon from 'mdi-react/AlternateEmailIcon';
import InformationOutlineIcon from 'mdi-react/InformationOutlineIcon';
import ThumbUpOutlineIcon from 'mdi-react/ThumbUpOutlineIcon';
import CommentAlertOutlineIcon from 'mdi-react/CommentAlertOutlineIcon';
import CloseCircleOutlineIcon from 'mdi-react/CloseCircleOutlineIcon';
import TooltipEditIcon from 'mdi-react/TooltipEditIcon';
import InboxArrowDownIcon from 'mdi-react/InboxArrowDownIcon';
import MenuDownIcon from 'mdi-react/MenuDownIcon';
import ReloadIcon from 'mdi-react/ReloadIcon';
import PenIcon from 'mdi-react/PenIcon';
import PackageVariantIcon from 'mdi-react/PackageVariantIcon';
import PackageVariantClosedIcon from 'mdi-react/PackageVariantClosedIcon';
import DeleteIcon from 'mdi-react/DeleteIcon';
import SendIcon from 'mdi-react/SendIcon'; // Novos ícones para previsão de cargas

import WeatherSunnyIcon from 'mdi-react/WeatherSunnyIcon';
import WeatherNightIcon from 'mdi-react/WeatherNightIcon';
import FullscreenIcon from 'mdi-react/FullscreenIcon';
import FullscreenExitIcon from 'mdi-react/FullscreenExitIcon'; // Ícones para modo mock

import DatabaseIcon from 'mdi-react/DatabaseIcon';
import DatabaseOffIcon from 'mdi-react/DatabaseOffIcon'; // Novos ícones para menus do sistema

import ClockOutlineIcon from 'mdi-react/ClockOutlineIcon';
import WarehouseIcon from 'mdi-react/WarehouseIcon';
import CalendarCheckIcon from 'mdi-react/CalendarCheckIcon';
import CalendarIcon from 'mdi-react/CalendarIcon';
import AccountSupervisorIcon from 'mdi-react/AccountSupervisorIcon';
import DomainIcon from 'mdi-react/DomainIcon';
import StoreIcon from 'mdi-react/StoreIcon';
import OfficeBuildingIcon from 'mdi-react/OfficeBuildingIcon';
import CogIcon from 'mdi-react/CogIcon';
import CogsIcon from 'mdi-react/CogsIcon';
import WrenchIcon from 'mdi-react/WrenchIcon';
import ToolsIcon from 'mdi-react/ToolsIcon';
import TruckIcon from 'mdi-react/TruckIcon';
import TruckDeliveryIcon from 'mdi-react/TruckDeliveryIcon';
import MapMarkerPathIcon from 'mdi-react/MapMarkerPathIcon';
import WeightIcon from 'mdi-react/WeightIcon';
import CartIcon from 'mdi-react/CartIcon';
import CartOutlineIcon from 'mdi-react/CartOutlineIcon';
import ShoppingIcon from 'mdi-react/ShoppingIcon';
import ReceiptIcon from 'mdi-react/ReceiptIcon';
import FileDocumentIcon from 'mdi-react/FileDocumentIcon';
import FileDocumentOutlineIcon from 'mdi-react/FileDocumentOutlineIcon';
import TruckFastIcon from 'mdi-react/TruckFastIcon';
import ClipboardTextIcon from 'mdi-react/ClipboardTextIcon';
import ContentCopyIcon from 'mdi-react/ContentCopyIcon';
import CurrencyUsdIcon from 'mdi-react/CurrencyUsdIcon';
import EyeOutlineIcon from 'mdi-react/EyeOutlineIcon';
import MonitorIcon from 'mdi-react/MonitorIcon';
import ChartLineIcon from 'mdi-react/ChartLineIcon';
import BellIcon from 'mdi-react/BellIcon';
import BellOutlineIcon from 'mdi-react/BellOutlineIcon';
import MessageIcon from 'mdi-react/MessageIcon';
import AlertIcon from 'mdi-react/AlertIcon';
import AlertOutlineIcon from 'mdi-react/AlertOutlineIcon';
import AlertCircleIcon from 'mdi-react/AlertCircleIcon';
import AlertCircleOutlineIcon from 'mdi-react/AlertCircleOutlineIcon';
import ExclamationIcon from 'mdi-react/ExclamationIcon';
import WarningIcon from 'mdi-react/WarningIcon'; // Ícones de arquivos para anexos
import TrophyVariantIcon from 'mdi-react/TrophyVariantIcon';
import FilePdfIcon from 'mdi-react/FilePdfIcon';
import FileWordIcon from 'mdi-react/FileWordIcon';
import FileExcelIcon from 'mdi-react/FileExcelIcon';
import FilePowerpointIcon from 'mdi-react/FilePowerpointIcon';
import DownloadIcon from 'mdi-react/DownloadIcon'; // Mapeamento de ícones FontAwesome para mdi-react
import AccountHardHatIcon from 'mdi-react/AccountHardHatIcon';
import TrophyAwardIcon from 'mdi-react/TrophyAwardIcon';
import FuelIcon from 'mdi-react/FuelIcon';
import FuelStationIcon from 'mdi-react/FuelStationIcon';
import FuelStationOutlineIcon from 'mdi-react/FuelStationOutlineIcon';
import ChartBoxOutlineIcon from 'mdi-react/ChartBoxOutlineIcon';
import MapMarkerRadiusIcon from 'mdi-react/MapMarkerRadiusIcon';
import LabelIcon from 'mdi-react/LabelIcon';
import CheckCircleOutlineIcon from 'mdi-react/CheckCircleOutlineIcon';
const ICON_MAP = {
  'check-circle-outline': CheckCircleOutlineIcon,
  'label': LabelIcon,
  'map-marker-radius': MapMarkerRadiusIcon,
  'chart-box-outline': ChartBoxOutlineIcon,
  'fuel': FuelIcon,
  'fuel-station': FuelStationIcon,
  'fuel-station-outline': FuelStationOutlineIcon,
  // Ações básicas
  edit: PencilOutlineIcon,
  delete: DeleteForeverIcon,
  trash: DeleteForeverIcon,
  close: CloseIcon,
  times: CloseIcon,
  check: CheckIcon,
  ban: BlockHelperIcon,
  search: MagnifyIcon,
  'pencil-outline': PencilOutlineIcon,
  'pencil': PencilIcon,
  // Usuários e perfis
  'user-edit': AccountEditIcon,
  'account-plus': AccountPlusIcon,
  'account-remove': AccountRemoveIcon,
  'account-multiple': AccountMultipleIcon,
  'account-group': AccountGroupIcon,
  key: KeyVariantIcon,
  // Navegação
  'chevron-down': ChevronDownIcon,
  'chevron-up': ChevronUpIcon,
  chevronDown: ChevronDownIcon,
  chevronUp: ChevronUpIcon,
  chevronLeft: ChevronLeftIcon,
  chevronRight: ChevronRightIcon,
  chevronDoubleLeft: ChevronDoubleLeftIcon,
  chevronDoubleRight: ChevronDoubleRightIcon,
  // Tabelas
  sort: SortIcon,
  sortAscending: SortAscendingIcon,
  sortDescending: SortDescendingIcon,
  // Formulários
  eye: EyeIcon,
  'eye-off': EyeOffIcon,
  // Status
  loading: LoadingIcon,
  refresh: AutorenewIcon,
  // Comunicação
  email: EmailIcon,
  mail: MailIcon,
  notification: NotificationsIcon,
  // Arquivos
  paperclip: PaperclipIcon,
  file: FileIcon,
  'file-pdf': FilePdfIcon,
  'file-word': FileWordIcon,
  'file-excel': FileExcelIcon,
  'file-powerpoint': FilePowerpointIcon,
  'file-text': FileDocumentIcon,
  // Usando FileDocumentIcon como alternativa
  'file-archive': FileDocumentIcon,
  // Usando FileDocumentIcon como alternativa
  'file-image': FileDocumentIcon,
  // Usando FileDocumentIcon como alternativa
  'file-document': FileDocumentIcon,
  'file-document-outline': FileDocumentOutlineIcon,
  download: DownloadIcon,
  // Ícones para previsão de cargas
  'weather-sunny': WeatherSunnyIcon,
  'weather-night': WeatherNightIcon,
  fullscreen: FullscreenIcon,
  'fullscreen-exit': FullscreenExitIcon,
  // Ícones para modo mock
  database: DatabaseIcon,
  'database-off': DatabaseOffIcon,
  // Social
  star: StarIcon,
  facebook: FacebookIcon,
  google: GooglePlusIcon,
  microsoft: MicrosoftOfficeIcon,
  // Outros
  settings: SettingsIcon,
  wallet: WalletIcon,
  menu: MenuIcon,
  plus: PlusIcon,
  minus: MinusIcon,
  arrowLeft: ArrowLeftIcon,
  arrowRight: ArrowRightIcon,
  'arrow-left': ArrowLeftIcon,
  'arrow-right': ArrowRightIcon,
  printer: PrinterIcon,
  reply: ReplyIcon,
  filter: FilterListIcon,
  timer: AvTimerIcon,
  account: AccountOutlineIcon,
  'account-search': AccountSearchIcon,
  'alternate-email': AlternateEmailIcon,
  'information-outline': InformationOutlineIcon,
  'thumb-up-outline': ThumbUpOutlineIcon,
  'comment-alert-outline': CommentAlertOutlineIcon,
  'close-circle-outline': CloseCircleOutlineIcon,
  'tooltip-edit': TooltipEditIcon,
  'inbox-arrow-down': InboxArrowDownIcon,
  'menu-down': MenuDownIcon,
  'reload': ReloadIcon,
  'pen': PenIcon,
  'package-variant': PackageVariantIcon,
  'package-variant-closed': PackageVariantClosedIcon,
  'delete': DeleteIcon,
  'send': SendIcon,
  // Ícones específicos para menus do sistema
  // Disponibilidade - Calendário/Agenda
  'calendar-clock': ClockOutlineIcon,
  'warehouse': WarehouseIcon,
  'calendar-check': CalendarCheckIcon,
  'timetable': CalendarIcon,
  // Usuários - Pessoas/Contas
  'account-multiple-outline': AccountMultipleIcon,
  'account-group-outline': AccountGroupIcon,
  'account-supervisor': AccountSupervisorIcon,
  // Clientes - Empresas/Organizações
  'domain': DomainIcon,
  'business': OfficeBuildingIcon,
  'store': StoreIcon,
  'office-building': OfficeBuildingIcon,
  // Grupos - Agrupamentos
  'group': AccountGroupIcon,
  // Operações - Processos/Atividades
  'cog': CogIcon,
  'cogs': CogsIcon,
  'wrench': WrenchIcon,
  'tools': ToolsIcon,
  // Cargas - Transporte/Logística
  'truck': TruckIcon,
  'map-marker-path': MapMarkerPathIcon,
  'truck-delivery': TruckDeliveryIcon,
  'weight': WeightIcon,
  // Pedidos - Compras/Vendas
  'cart': CartIcon,
  'cart-outline': CartOutlineIcon,
  'shopping': ShoppingIcon,
  'receipt': ReceiptIcon,
  // CTEs - Documentos de Transporte
  'file-document': FileDocumentIcon,
  'file-document-outline': FileDocumentOutlineIcon,
  'truck-fast': TruckFastIcon,
  'clipboard-text': ClipboardTextIcon,
  'content-copy': ContentCopyIcon,
  // Notas Fiscais - Documentos Fiscais
  'receipt-text': ReceiptIcon,
  'file-invoice': FileDocumentIcon,
  'file-invoice-dollar': CurrencyUsdIcon,
  'currency-usd': CurrencyUsdIcon,
  // Acompanhamentos - Monitoramento
  'eye-outline': EyeOutlineIcon,
  'monitor-dashboard': MonitorIcon,
  'chart-line': ChartLineIcon,
  'trackpad': EyeIcon,
  // Notificações - Alertas
  'bell': BellIcon,
  'bell-outline': BellOutlineIcon,
  'bell-ring': BellIcon,
  'bell-ring-outline': BellOutlineIcon,
  'message': MessageIcon,
  // Divergências - Problemas/Alertas
  'alert': AlertIcon,
  'alert-outline': AlertOutlineIcon,
  'alert-circle': AlertCircleIcon,
  'alert-circle-outline': AlertCircleOutlineIcon,
  'exclamation': ExclamationIcon,
  'warning': WarningIcon,
  'trophy-variant': TrophyVariantIcon,
  'account-hard-hat': AccountHardHatIcon,
  'trophy-award': TrophyAwardIcon
};

const Icon = ({
  name,
  size = 18,
  ...props
}) => {
  const IconComponent = ICON_MAP[name];

  if (!IconComponent) {
    console.warn(`Ícone não encontrado: ${name}`);
    return null;
  }

  return <IconComponent size={size} {...props} />;
};

Icon.propTypes = {
  name: PropTypes.string.isRequired,
  size: PropTypes.number
};
export default Icon;
